/**
 * Get person fullname
 * @param person
 * @returns {string}
 */
export const personFullname = (person) => {
    if (!person || !person.firstName) {
        return "";
    }
    let name = person.firstName;
    if (person.middleName) {
        name += " " + person.middleName;
    }
    if (person.lastName) {
        name += " " + person.lastName;
    }
    if (person.nickName) {
        name = `"${person.nickName}" / ${name}`;
    }
    return name.trim();
};
